import React from 'react'
import { withRouter  } from "react-router-dom";
import './styles.scss'

const Footer = (props) => {
    const openFaq = () => {
        document.getElementById('faq').classList.add("active");
    }

    const openPage = (url) => {
        props.history.push( url )
    }
    return (
        <footer>
            <div className="container">
                <span onClick={() => openFaq()}>FAQ</span>
                <span onClick={() => openPage("/nota-prawna")}>Nota Prawna</span>
                {/* <span onClick={() => openPage("/ochrona-danych")}>Ochrona Danych</span> */}
                {/* <a href="https://www.grenkeleasing.pl/pl/footernavigation/metryka-strony.html" target="_blank">Metryka Strony</a> */}
                <a href="https://newonline.leasingoptymalny.pl/od/"  target="_blank">Ochrona Danych</a>
                <p>© <a href="http://www.grenke.pl" target="_blank">GRENKE</a> { new Date().getFullYear()  }</p>
            </div>
        </footer>
    )
}

export default withRouter(Footer);